import React from 'react';

const FormAttributeTooltip = ({ id }) => {
    return (
        <div className="bg-white border border-gray-200 shadow-lg rounded-md overflow-hidden w-100">
            {/* Header */}
            <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                <h3 className="text-sm font-medium text-gray-700">How to Use Form Attribute ID</h3>
            </div>

            {/* Content */}
            <div className="p-4 space-y-3 text-sm">
                <div className="space-y-2">
                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-medium mr-2 mt-0.5">
                            1
                        </div>
                        <p className="text-gray-700">
                            Copy the Form Attribute ID by clicking the clipboard icon.
                        </p>
                    </div>

                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-medium mr-2 mt-0.5">
                            2
                        </div>
                        <p className="text-gray-700">
                            In your HTML form, add a new attribute to the <code className="font-mono text-xs bg-gray-100 px-1 py-0.5 rounded">&lt;form&gt;</code> tag:
                        </p>
                    </div>

                    <div className="bg-gray-100 p-3 rounded-md border-l-4 border-blue-500 font-mono text-xs overflow-x-auto whitespace-nowrap ml-7">
                        &lt;form <span className="text-purple-600 font-semibold">data-form-submission-id="<span className="text-green-600 italic">PASTE_ID_HERE</span>"</span> ...other attributes...&gt;
                    </div>

                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-medium mr-2 mt-0.5">
                            3
                        </div>
                        <p className="text-gray-700">
                            This connects your form to our tracking system and enables advanced analytics and form submission handling.
                        </p>
                    </div>
                </div>

                {/* Note */}
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded-r-md">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm text-yellow-700">
                                <span className="font-medium">Note:</span> The attribute must be added directly to the form element, not to its container or children elements.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormAttributeTooltip;